import mitt, { type Emitter } from 'mitt';

/**
 * Application event bus — typed mitt instance. Replaces stringly-typed
 * `document.dispatchEvent(new CustomEvent('login'))` / `window.addEventListener`
 * pairs that depended on DOM bubble propagation.
 *
 * Add new events here as needed. Keep payloads small + serializable.
 */
export type SubscribeEventPayload = {
  status_type: 'subscribe' | 'unsubscribe';
  subscription: PushSubscriptionJSON;
  browser: string;
  user_agent?: string;
};

export type AppEvents = {
  login: void;
  logout: void;
  subscribe: SubscribeEventPayload;
};

export const bus: Emitter<AppEvents> = mitt<AppEvents>();
